import React from 'react';
import PrimaryButton from '../buttons/PrimaryButton';
import { AppInfoContext } from '../context/AppInfo';
// javascript plugin used to create scrollbars on windows

const MiniWindow = ({ children, cta, ctaText, open, setOpen }) => {
  const { isMobile } = React.useContext(AppInfoContext);
  return (
    <>
      <div
        style={{
          borderRadius: 12,
          backgroundColor: 'white',
          boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.2)',
          padding: '12px 12px',
          bottom: 12,
          right: isMobile ? window.innerWidth * 0.025 : 12,
          width: isMobile ? '95%' : null,
          zIndex: 1200,
          position: 'fixed',
          display: open ? 'block' : 'none'
        }}
      >
        <div style={{ position: 'relative', width: '100%' }}>
          <p
            style={{
              cursor: 'pointer',
              color: 'black',
              textAlign: 'center',
              margin: 0,
              fontSize: 12,
              position: 'absolute',
              top: -35,
              right: 0,
              width: 18,
              height: 18,
              borderRadius: '50%',
              background: 'white'
            }}
            onClick={() => setOpen(false)}
          >
            <i className='fa fa-close' />
          </p>
          <table onClick={!ctaText && cta} style={{ cursor: 'pointer' }}>
            <tr>
              <td><p style={{ marginBottom: 0, fontSize: 14 }}>{children}</p></td>
              {(cta && ctaText) && <td style={{ paddingLeft: 20 }}><PrimaryButton scale={0.9} onClick={cta}>{ctaText}</PrimaryButton></td>}
            </tr>
          </table>
        </div>
      </div>
    </>
  );
};

export default MiniWindow;
